"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MergedCrfItem = exports.MergedVisit = exports.MergedPageDetail = exports.MergedPage = exports.MergedDomain = exports.MergedStudySpecExcludeTriggers = exports.MergedStudySpec = exports.StudyActionAudit = exports.StudyMailTemplate = exports.StudyUserApiKey = exports.StudyUserRole = exports.StudyUserSummary = exports.StudyUserNeedMigrate = exports.StudyUser = exports.Study = exports.StudyEssential = exports.StudyUserActivateStatus = exports.StudyMailTemplateType = exports.StudyAction = exports.StudyStatus = void 0;
var StudyStatus;
(function (StudyStatus) {
    StudyStatus["Wait"] = "WAIT";
    StudyStatus["Ongoing"] = "ONGOING";
    StudyStatus["Closed"] = "CLOSED";
})(StudyStatus = exports.StudyStatus || (exports.StudyStatus = {}));
var StudyAction;
(function (StudyAction) {
    StudyAction["Lock"] = "LOCK";
    StudyAction["Unlock"] = "UNLOCK";
    StudyAction["Close"] = "CLOSE";
    StudyAction["Reopen"] = "REOPEN";
})(StudyAction = exports.StudyAction || (exports.StudyAction = {}));
var StudyMailTemplateType;
(function (StudyMailTemplateType) {
    StudyMailTemplateType["SaeReport"] = "SAE_REPORT";
    StudyMailTemplateType["AeReport"] = "AE_REPORT";
})(StudyMailTemplateType = exports.StudyMailTemplateType || (exports.StudyMailTemplateType = {}));
var StudyUserActivateStatus;
(function (StudyUserActivateStatus) {
    StudyUserActivateStatus["Inactivated"] = "INACTIVATED";
    StudyUserActivateStatus["Activated"] = "ACTIVATED";
    StudyUserActivateStatus["Terminated"] = "TERMINATED";
})(StudyUserActivateStatus = exports.StudyUserActivateStatus || (exports.StudyUserActivateStatus = {}));
// TODO: Deprecated, maven-rest로 이관된 StudyEssential 사용하도록 수정 필요. (2023.08.18)
class StudyEssential {
}
exports.StudyEssential = StudyEssential;
// TODO: Deprecated, maven-rest로 이관된 Study 사용하도록 수정 필요. (2023.08.18)
class Study {
}
exports.Study = Study;
class StudyUser {
}
exports.StudyUser = StudyUser;
class StudyUserNeedMigrate {
}
exports.StudyUserNeedMigrate = StudyUserNeedMigrate;
class StudyUserSummary {
}
exports.StudyUserSummary = StudyUserSummary;
class StudyUserRole {
}
exports.StudyUserRole = StudyUserRole;
class StudyUserApiKey {
}
exports.StudyUserApiKey = StudyUserApiKey;
class StudyMailTemplate {
}
exports.StudyMailTemplate = StudyMailTemplate;
class StudyActionAudit {
}
exports.StudyActionAudit = StudyActionAudit;
class MergedStudySpec {
}
exports.MergedStudySpec = MergedStudySpec;
class MergedStudySpecExcludeTriggers {
}
exports.MergedStudySpecExcludeTriggers = MergedStudySpecExcludeTriggers;
class MergedDomain {
}
exports.MergedDomain = MergedDomain;
class MergedPage {
}
exports.MergedPage = MergedPage;
class MergedPageDetail {
}
exports.MergedPageDetail = MergedPageDetail;
class MergedVisit {
}
exports.MergedVisit = MergedVisit;
class MergedCrfItem {
}
exports.MergedCrfItem = MergedCrfItem;
//# sourceMappingURL=study.js.map